import {createSlice} from '@reduxjs/toolkit'

export const superUserSlice = createSlice({
  name: 'superUser',
  initialState: {
    tenantList: [],
    azureRole: '',
    isTenantDataLoading: false,
    isSuperUser: false,
    isTenantDataError: null
  },
  reducers: {
    setAzureRole: (state, action) => {
      state.azureRole = action.payload
    },
    setTenantDataLoading: (state, action) => {
      state.isTenantDataLoading = action.payload
    },
    setTenantList: (state, action) => {
      state.tenantList = action.payload
    },
    setSuperUser: (state, action) => {
      state.isSuperUser = action.payload
    },
    setTenantDataError: (state, action) => {
      state.isTenantDataError = action.payload
    }
  }
})

export const {setAzureRole, setTenantDataLoading, setTenantList, setSuperUser, setTenantDataError} =
  superUserSlice.actions

export default superUserSlice.reducer
